import type RuleId from "../fields/RuleId";

export const RULE_SHOW_EVENT_NAME = "rule.show";
class RuleShowEvent extends Event {
  public readonly ruleId: RuleId;

  constructor(ruleId: RuleId) {
    super(RULE_SHOW_EVENT_NAME, { bubbles: false });
    this.ruleId = ruleId;
  }

  send() {
    setTimeout(() => document.dispatchEvent(this));
  }
}

export default RuleShowEvent;
